module.exports = __webpack_public_path__ + "media/images/pic/team_management_default-7e1771dc093e9d34e5c1b6a7eca8f460.svg";